import VueRouter from 'vue-router';
import moment from "moment";

export default new VueRouter({
    mode: 'history',

    routes: [
        {
            path: '/',
            redirect: () => '/dashboards/my-focus'
        },
        {
            path: '/login',
            component: require('./pages/Login').default,
            meta: {
                title: 'Login'
            }
        },
        {
            path: '/passwords/reset',
            component: require('./components/Blank').default,
            children: [
                {
                    path: '',
                    component: require('./pages/PasswordResets/Email').default,
                    meta: {
                        title: 'Reset Password'
                    }
                },
                {
                    path: ':token',
                    component: require('./pages/PasswordResets/Reset').default,
                    props: true,
                    meta: {
                        title: 'Reset Password'
                    }
                }
            ]
        },
        {
            path: '/',
            component: require('./components/Layout/Index.vue').default,
            meta: {auth: true},
            children: [
                {
                    path: 'dashboards',
                    meta: {section: 'dashboards'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: 'advertisement',
                            redirect: () => 'advertisement/' + moment().format('Y')
                        },
                        {
                            path: 'advertisement/:year',
                            component: require('./pages/Dashboards/Advertisement').default,
                            props: true,
                            meta: {
                                title: 'Advertisement'
                            }
                        },
                        {
                            path: 'opportunities',
                            component: require('./pages/Dashboards/Opportunities').default,
                            meta: {
                                title: 'Opportunities'
                            }
                        },
                        {
                            path: 'subscriptions',
                            component: require('./pages/Dashboards/Subscriptions').default,
                            meta: {
                                title: 'Subscriptions'
                            }
                        },
                        {
                            path: 'my-focus',
                            component: require('./pages/Dashboards/MyFocus').default,
                            meta: {
                                title: 'My Focus'
                            }
                        },
                        {
                            path: 'sales',
                            component: require('./pages/Dashboards/Sales').default,
                            meta: {
                                title: 'Sales'
                            }
                        },
                        {
                            path: 'opportunities',
                            component: require('./pages/Dashboards/Opportunities').default,
                            meta: {
                                title: 'Opportunities'
                            }
                        },
                        {
                            path: 'meetings',
                            component: require('./pages/Dashboards/Meetings').default,
                            meta: {
                                title: 'Meetings'
                            }
                        },
                        {
                            path: 'competitions',
                            component: require('./pages/Dashboards/Competitions').default,
                            meta: {
                                title: 'Competitions'
                            }
                        },
                        {
                            path: 'partnership-forecast',
                            component: require('./pages/Dashboards/PartnershipForecast').default,
                            meta: {
                                title: 'Partnership Forecast'
                            }
                        },
                        {
                            path: 'membership-forecast',
                            component: require('./pages/Dashboards/MembershipForecast').default,
                            meta: {
                                title: 'Membership Forecast'
                            }
                        },
                        {
                            path: 'topics',
                            component: require('./pages/Dashboards/Topics').default,
                            meta: {
                                title: 'Topics'
                            }
                        },
                        {
                            path: 'topics/:topicId',
                            component: require('./pages/Dashboards/TopicDetails/Index.vue').default,
                            meta: {
                                title: 'Topic Details'
                            }
                        },
                    ]
                },
                {
                    path: 'passwords/edit',
                    component: require('./pages/User/Passwords/Edit').default,
                    meta: {
                        title: 'Update Password',
                        section: 'user'
                    }
                },
                {
                    path: 'companies/imports/create',
                    component: require('./pages/Companies/CompanyImports/Create').default,
                    meta: {
                        title: 'Import Companies',
                        section: 'companies'
                    }
                },
                {
                    path: 'content',
                    component: require('./pages/Content/ContentPortals/List.vue').default,
                    meta: {
                        title: 'Content Portals',
                        section: 'content'
                    }
                },
                {
                    path: 'companies',
                    meta: {section: 'companies'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Companies/Companies/List').default,
                            meta: {
                                title: 'Companies'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Companies/Companies/Create').default,
                            meta: {
                                title: 'Create Company'
                            }
                        },
                        {
                            path: ':companyId',
                            component: require('./pages/Companies/Companies/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Company'
                            },
                            children: [
                                {
                                    path: '',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/Dashboard').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/Edit').default,
                                    meta: {subsection: 'edit'}
                                },
                                {
                                    path: 'people',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/PersonList').default,
                                    meta: {subsection: 'people'}
                                },
                                {
                                    path: 'people/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreatePerson').default,
                                    meta: {subsection: 'people'}
                                },
                                {
                                    path: 'subscriptions',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/SubscriptionList').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'subscriptions/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateSubscription').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'subscriptions/:subscriptionId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EditSubscription').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'invoices',
                                    component: require('./pages/Shared/Tabs/InvoiceList').default,
                                    meta: {subsection: 'invoices'}
                                },
                                {
                                    path: 'invoices/:invoiceId',
                                    component: require('./pages/Shared/Tabs/EditInvoice').default,
                                    meta: {subsection: 'invoices'},
                                    props: true
                                },
                                {
                                    path: 'orders',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/OrderList').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'orders/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateOrder').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'orders/:orderId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EditOrder').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'orders/:orderId/ads/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateAd').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'orders/:orderId/time-based-ads/:timeBasedAdId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EditTimeBasedAd').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'orders/:orderId/publication-based-ads/:publicationBasedAdId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EditPublicationBasedAd').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'order-payments/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateOrderPayment').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'order-confirmations',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/OrderConfirmationList').default,
                                    meta: {subsection: 'order-confirmations'}
                                },
                                {
                                    path: 'partnership-activity-mails',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/PartnershipActivityMailList').default,
                                    meta: {subsection: 'partnership-activity-mails'}
                                },
                                {
                                    path: 'partnership-activity-mails/:partnershipActivityMailId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/ShowPartnershipActivityMail').default,
                                    meta: {subsection: 'partnership-activity-mails'},
                                    props: true
                                },
                                {
                                    path: 'emails',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EmailList').default,
                                    meta: {subsection: 'emails'}
                                },
                                {
                                    path: 'timeline',
                                    component: require('./pages/Shared/Tabs/Timeline').default,
                                    meta: {subsection: 'timeline'}
                                },
                                {
                                    path: 'opportunities',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/OpportunityList').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'opportunities/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateOpportunity').default,
                                    meta: {subsection: 'sales'}
                                },
                                {
                                    path: 'opportunities/:opportunityId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/EditOpportunity').default,
                                    meta: {subsection: 'sales'},
                                    props: true
                                },
                                {
                                    path: 'order-confirmations/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreateOrderConfirmation').default,
                                    meta: {subsection: 'order-confirmations'},
                                    props: true
                                },
                                {
                                    path: 'portals',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanyList').default,
                                    meta: {subsection: 'portals'}
                                },
                                {
                                    path: 'portals/create',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/CreatePortalCompany').default,
                                    meta: {subsection: 'portals'}
                                },
                                {
                                    path: 'portals/:portalCompanyId',
                                    component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/Index').default,
                                    meta: {subsection: 'portals'},
                                    props: true,
                                    children: [
                                        {
                                            path: '',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/Dashboard').default,
                                        },
                                        {
                                            path: 'brands',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/BrandList').default,
                                        },
                                        {
                                            path: 'brands/create',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/CreateBrand').default,
                                        },
                                        {
                                            path: 'brands/:brandId/edit',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/EditBrand').default,
                                            props: true
                                        },
                                        {
                                            path: 'contacts',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/ContactList').default,
                                        },
                                        {
                                            path: 'contacts/create',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/CreateContact').default,
                                        },
                                        {
                                            path: 'contacts/:contactId/edit',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/EditContact').default,
                                            props: true
                                        },
                                        {
                                            path: 'edit',
                                            component: require('./pages/Companies/Companies/Edit/Tabs/PortalCompanies/Edit').default,
                                        },
                                    ]
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'people/imports/create',
                    component: require('./pages/People/PersonImports/Create').default,
                    meta: {
                        title: 'Import People',
                        section: 'people'
                    }
                },
                {
                    path: 'people',
                    meta: {section: 'people'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/People/People/List').default,
                            meta: {
                                title: 'People'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/People/People/Create').default,
                            meta: {
                                title: 'Create Person'
                            }
                        },
                        {
                            path: ':personId',
                            component: require('./pages/People/People/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Person'
                            },
                            children: [
                                {
                                    path: '',
                                    component: require('./pages/People/People/Edit/Tabs/Dashboard').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/People/People/Edit/Tabs/Edit').default,
                                    meta: {subsection: 'edit'}
                                },
                                {
                                    path: 'subscriptions',
                                    component: require('./pages/People/People/Edit/Tabs/SubscriptionList').default,
                                    meta: {subsection: 'subscriptions'}
                                },
                                {
                                    path: 'subscriptions/create',
                                    component: require('./pages/People/People/Edit/Tabs/CreateSubscription').default,
                                    meta: {subsection: 'subscriptions'}
                                },
                                {
                                    path: 'subscriptions/:subscriptionId',
                                    component: require('./pages/People/People/Edit/Tabs/EditSubscription').default,
                                    meta: {subsection: 'subscriptions'},
                                    props: true
                                },
                                {
                                    path: 'invoices',
                                    component: require('./pages/Shared/Tabs/InvoiceList').default,
                                    meta: {subsection: 'invoices'}
                                },
                                {
                                    path: 'invoices/:invoiceId',
                                    component: require('./pages/Shared/Tabs/EditInvoice').default,
                                    meta: {subsection: 'invoices'},
                                    props: true
                                },
                                {
                                    path: 'emails',
                                    component: require('./pages/People/People/Edit/Tabs/EmailList').default,
                                    meta: {subsection: 'emails'}
                                },
                                {
                                    path: 'timeline',
                                    component: require('./pages/Shared/Tabs/Timeline').default,
                                    meta: {subsection: 'timeline'}
                                },
                                {
                                    path: 'portals',
                                    component: require('./pages/People/People/Edit/Tabs/PortalList').default,
                                    meta: {subsection: 'portals'}
                                },
                                {
                                    path: 'partnership-activity-mails',
                                    component: require('./pages/People/People/Edit/Tabs/PartnershipActivityMailList').default,
                                    meta: {subsection: 'partnership-activity-mails'}
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'orders',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Orders/Orders/List').default,
                            meta: {
                                title: 'Orders'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Orders/Orders/Create').default,
                            meta: {
                                title: 'Create Order'
                            }
                        }
                    ]
                },
                {
                    path: 'reminders',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Relations/Reminders/List').default,
                            meta: {
                                title: 'Reminders'
                            }
                        }
                    ]
                },
                {
                    path: 'projects',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Relations/Projects/List').default,
                            meta: {
                                title: 'Projects'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Relations/Projects/Create.vue').default,
                            meta: {
                                title: 'Create Project'
                            }
                        },
                        {
                            path: ':projectId',
                            component: require('./pages/Relations/Projects/Show/Index.vue').default,
                            meta: {
                                title: 'Project Details'
                            },
                            children: [
                                {
                                    path: '',
                                    redirect: () => './dashboard'
                                },
                                {
                                    path: 'dashboard',
                                    component: require('./pages/Relations/Projects/Show/Dashboard.vue').default,
                                },
                                {
                                    path: 'project-leads',
                                    component: require('./pages/Relations/Projects/Show/ProjectLeadList.vue').default,
                                },
                                {
                                    path: 'project-milestones',
                                    component: require('./pages/Relations/Projects/Show/ProjectMilestoneList.vue').default,
                                },
                                {
                                    path: 'project-reminders',
                                    component: require('./pages/Relations/Projects/Show/ProjectReminderList.vue').default,
                                },
                                {
                                    path: 'project-opportunities',
                                    component: require('./pages/Relations/Projects/Show/ProjectOpportunityList.vue').default,
                                },
                                {
                                    path: 'project-ads',
                                    component: require('./pages/Relations/Projects/Show/ProjectAdList.vue').default,
                                },
                                {
                                    path: 'project-partners',
                                    component: require('./pages/Relations/Projects/Show/ProjectPartnerList.vue').default,
                                },
                                {
                                    path: 'project-managers',
                                    component: require('./pages/Relations/Projects/Show/ProjectManagerList.vue').default,
                                },
                                {
                                    path: 'project-sellers',
                                    component: require('./pages/Relations/Projects/Show/ProjectSellerList.vue').default,
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/Relations/Projects/Show/Edit.vue').default,
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'memberships',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Relations/Memberships/List').default,
                            meta: {
                                title: 'Memberships'
                            }
                        }
                    ]
                },
                {
                    path: 'partnerships',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Relations/Partnerships/List').default,
                            meta: {
                                title: 'Partnerships'
                            }
                        }
                    ]
                },
                {
                    path: 'partnership-activity-mails',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Relations/PartnershipActivityMails/List').default,
                            meta: {
                                title: 'Partnership Activity Mails'
                            }
                        }
                    ]
                },
                {
                    path: 'publications',
                    meta: {section: 'publications'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Publications/List').default,
                            meta: {
                                title: 'Publications'
                            }
                        },
                        {
                            path: ':publicationId',
                            component: require('./pages/Administration/Publications/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Publication'
                            },
                            children: [
                                {
                                    path: '',
                                    component: require('./pages/Administration/Publications/Edit/Tabs/Dashboard').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/Administration/Publications/Edit/Tabs/Edit').default,
                                    meta: {subsection: 'edit'}
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'capacity',
                    meta: {section: 'publications'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Publications/Capacity/List').default,
                            meta: {
                                title: 'Capacity'
                            }
                        }
                    ]
                },
                {
                    path: 'order-payments',
                    meta: {section: 'relations'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: 'create',
                            component: require('./pages/Orders/OrderPayments/Create').default,
                            meta: {
                                title: 'Invoice Orders'
                            }
                        }
                    ]
                },
                {
                    path: 'invoices',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Invoices/List').default,
                            meta: {
                                title: 'Invoices'
                            }
                        }
                    ]
                },
                {
                    path: 'users',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Users/List').default,
                            meta: {
                                title: 'Users'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/Users/Create').default,
                            meta: {
                                title: 'Create User'
                            }
                        },
                        {
                            path: ':userId',
                            component: require('./pages/Administration/Users/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit User'
                            },
                            children: [
                                {
                                    path: '',
                                    component: require('./pages/Administration/Users/Edit/Tabs/Dashboard/Overview').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'dashboard/advertising',
                                    component: require('./pages/Administration/Users/Edit/Tabs/Dashboard/Advertising').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'dashboard/partnerships',
                                    component: require('./pages/Administration/Users/Edit/Tabs/Dashboard/Partnerships').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'dashboard/commission',
                                    component: require('./pages/Administration/Users/Edit/Tabs/Dashboard/Commission').default,
                                    meta: {subsection: 'dashboard'}
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/Administration/Users/Edit/Tabs/Edit').default,
                                    meta: {subsection: 'edit'}
                                },
                                {
                                    path: 'targets',
                                    component: require('./pages/Administration/Users/Edit/Tabs/TargetList').default,
                                    meta: {subsection: 'targets'}
                                },
                                {
                                    path: 'logins',
                                    component: require('./pages/Administration/Users/Edit/Tabs/LoginList').default,
                                    meta: {subsection: 'logins'}
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'subscription-types',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/SubscriptionTypes/List').default,
                            meta: {
                                title: 'Subscription Types'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/SubscriptionTypes/Create').default,
                            meta: {
                                title: 'Create Subscription Type'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/SubscriptionTypes/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Subscription Type'
                            }
                        }
                    ]
                },
                {
                    path: 'payment-conditions',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/PaymentConditions/List').default,
                            meta: {
                                title: 'Payment Conditions'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/PaymentConditions/Create').default,
                            meta: {
                                title: 'Create Payment Condition'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/PaymentConditions/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Payment Condition'
                            }
                        }
                    ]
                },
                {
                    path: 'project-categories',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/ProjectCategories/List').default,
                            meta: {
                                title: 'Project Categories'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/ProjectCategories/Create').default,
                            meta: {
                                title: 'Create Project Category'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/ProjectCategories/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Project Category'
                            }
                        }
                    ]
                },
                {
                    path: 'legal-texts',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/LegalTexts/List').default,
                            meta: {
                                title: 'Legal Texts'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/LegalTexts/Create').default,
                            meta: {
                                title: 'Create Legal Text'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/LegalTexts/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Legal Text'
                            }
                        }
                    ]
                },
                {
                    path: 'competitions',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Competitions/List').default,
                            meta: {
                                title: 'Competitions'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/Competitions/Create').default,
                            meta: {
                                title: 'Create Competition'
                            }
                        },
                        {
                            path: ':competitionId/edit',
                            component: require('./pages/Administration/Competitions/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Competition'
                            }
                        },
                        {
                            path: ':competitionId/teams/:competitionTeamId',
                            redirect: to => to.params.competitionId + '/teams/' + to.params.competitionTeamId + '/edit'
                        },
                        {
                            path: ':competitionId/teams/:competitionTeamId/edit',
                            component: require('./pages/Administration/CompetitionTeams/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Competition Team'
                            }
                        }
                    ]
                },
                {
                    path: 'untracked-email-addresses',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/UntrackedEmailAddresses/List').default,
                            meta: {
                                title: 'Untracked Email Addresses'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/UntrackedEmailAddresses/Create').default,
                            meta: {
                                title: 'Create Untracked Email Address'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/UntrackedEmailAddresses/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Untracked Email Address'
                            }
                        }
                    ]
                },
                {
                    path: 'retention-touchpoints',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/RetentionTouchpoints/List').default,
                            meta: {
                                title: 'Retention Touchpoints'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/RetentionTouchpoints/Create').default,
                            meta: {
                                title: 'Create Retention Touchpoint'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/RetentionTouchpoints/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Retention Touchpoint'
                            }
                        }
                    ]
                },
                {
                    path: 'tags',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Tags/List').default,
                            meta: {
                                title: 'Tags'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/Tags/Create').default,
                            meta: {
                                title: 'Create Tag'
                            }
                        },
                        {
                            path: ':id/edit',
                            component: require('./pages/Administration/Tags/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Tag'
                            }
                        }
                    ]
                },
                {
                    path: 'portals',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Portals/List').default,
                            meta: {
                                title: 'Portals'
                            }
                        },
                        {
                            path: 'create',
                            component: require('./pages/Administration/Portals/Create').default,
                            meta: {
                                title: 'Create Portal'
                            }
                        },
                        {
                            path: ':portalId',
                            component: require('./pages/Administration/Portals/Edit').default,
                            props: true,
                            meta: {
                                title: 'Edit Portal'
                            },
                            children: [
                                {
                                    path: '',
                                    redirect: () => 'dashboard/' + moment().format('Y')
                                },
                                {
                                    path: 'dashboard',
                                    redirect: () => 'dashboard/' + moment().format('Y')
                                },
                                {
                                    path: 'dashboard/:year',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/Dashboard').default,
                                    meta: {subsection: 'dashboard'},
                                    props: true
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId/dashboard',
                                    redirect: () => 'dashboard/' + moment().format('Y')
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId/dashboard/:year',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/PublicationBasedChannelDashboard').default,
                                    meta: {subsection: 'dashboard'},
                                    props: true
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId/dashboard',
                                    redirect: () => 'dashboard/' + moment().format('Y')
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId/dashboard/:year',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard').default,
                                    meta: {subsection: 'dashboard'},
                                    props: true
                                },
                                {
                                    path: 'time-based-subchannels/:timeBasedSubchannelId/dashboard',
                                    redirect: () => 'dashboard/' + moment().format('Y')
                                },
                                {
                                    path: 'time-based-subchannels/:timeBasedSubchannelId/dashboard/:year',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/TimeBasedSubchannelDashboard').default,
                                    meta: {subsection: 'dashboard'},
                                    props: true
                                },
                                {
                                    path: 'edit',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/Edit').default,
                                    meta: {subsection: 'edit'}
                                },
                                {
                                    path: 'subscription-types',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/SubscriptionTypeList').default,
                                    meta: {subsection: 'subscription-types'}
                                },
                                {
                                    path: 'subscription-types/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreateSubscriptionType').default,
                                    meta: {subsection: 'subscription-types'}
                                },
                                {
                                    path: 'subscription-types/:subscriptionTypeId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditSubscriptionType').default,
                                    meta: {subsection: 'subscription-types'},
                                    props: true
                                },
                                {
                                    path: 'mailing-lists',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/MailingListList').default,
                                    meta: {subsection: 'mailing-lists'}
                                },
                                {
                                    path: 'mailing-lists/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreateMailingList').default,
                                    meta: {subsection: 'mailing-lists'}
                                },
                                {
                                    path: 'mailing-lists/:mailingListId/edit',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditMailingList').default,
                                    meta: {subsection: 'mailing-lists'},
                                    props: true
                                },
                                {
                                    path: 'content',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/Content/Index').default,
                                    meta: {subsection: 'content'},
                                    children: [
                                        {
                                            path: '',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/Dashboard').default,
                                        },
                                        {
                                            path: 'pages',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentPages').default,
                                        },
                                        {
                                            path: 'pages/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentPages/Create').default,
                                        },
                                        {
                                            path: 'pages/:contentPageId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentPages/Edit').default,
                                        },
                                        {
                                            path: 'pages/:contentPageId/content-rows/:contentRowId/content-blocks/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentPages/ContentBlocks/Create.vue').default,
                                        },
                                        {
                                            path: 'pages/:contentPageId/content-rows/:contentRowId/content-blocks/:contentBlockId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentPages/ContentBlocks/Edit.vue').default,
                                        },
                                        {
                                            path: 'layouts',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentLayouts').default,
                                        },
                                        {
                                            path: 'layouts/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentLayouts/Create').default,
                                        },
                                        {
                                            path: 'layouts/:contentLayoutId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentLayouts/Edit').default,
                                        },
                                        {
                                            path: 'layouts/:contentLayoutId/content-rows/:contentRowId/content-blocks/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentLayouts/ContentBlocks/Create.vue').default,
                                        },
                                        {
                                            path: 'layouts/:contentLayoutId/content-rows/:contentRowId/content-blocks/:contentBlockId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentLayouts/ContentBlocks/Edit.vue').default,
                                        },
                                        {
                                            path: 'event-categories',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEventCategories').default,
                                        },
                                        {
                                            path: 'event-categories/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEventCategories/Create').default,
                                        },
                                        {
                                            path: 'event-categories/:contentEventCategoryId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEventCategories/Edit').default,
                                        },
                                        {
                                            path: 'article-categories',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleCategories').default,
                                        },
                                        {
                                            path: 'article-categories/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleCategories/Create').default,
                                        },
                                        {
                                            path: 'article-categories/:contentArticleCategoryId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleCategories/Edit').default,
                                        },
                                        {
                                            path: 'article-flags',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleFlags').default,
                                        },
                                        {
                                            path: 'article-flags/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleFlags/Create').default,
                                        },
                                        {
                                            path: 'article-flags/:contentArticleFlagId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleFlags/Edit').default,
                                        },
                                        {
                                            path: 'article-flag-schedules',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleFlagSchedules').default,
                                        },
                                        {
                                            path: 'article-tags',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleTags').default,
                                        },
                                        {
                                            path: 'article-tags/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleTags/Create').default,
                                        },
                                        {
                                            path: 'article-tags/:contentArticleTagId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleTags/Edit').default,
                                        },
                                        {
                                            path: 'topics',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopics').default,
                                        },
                                        {
                                            path: 'topics/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopics/Create').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopics/Edit').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/sponsorships/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopicSponsorships/Create').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/sponsorships/:contentTopicSponsorshipId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopicSponsorships/Edit').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/articles/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopicArticles/Create').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/articles/:contentTopicArticleId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopicArticles/Edit').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/content-rows/:contentRowId/content-blocks/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopics/ContentBlocks/Create.vue').default,
                                        },
                                        {
                                            path: 'topics/:contentTopicId/content-rows/:contentRowId/content-blocks/:contentBlockId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentTopics/ContentBlocks/Edit.vue').default,
                                        },
                                        {
                                            path: 'sitemap-links',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SitemapLinks').default,
                                        },
                                        {
                                            path: 'sitemap-links/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SitemapLinks/Create').default,
                                        },
                                        {
                                            path: 'sitemap-links/:sitemapLinkId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SitemapLinks/Edit').default,
                                        },
                                        {
                                            path: 'top-menu-links',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/TopMenuLinks').default,
                                        },
                                        {
                                            path: 'top-menu-links/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/TopMenuLinks/Create').default,
                                        },
                                        {
                                            path: 'top-menu-links/:topMenuLinkId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/TopMenuLinks/Edit').default,
                                        },
                                        {
                                            path: 'secondary-menu-links',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SecondaryMenuLinks').default,
                                        },
                                        {
                                            path: 'secondary-menu-links/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SecondaryMenuLinks/Create').default,
                                        },
                                        {
                                            path: 'secondary-menu-links/:secondaryMenuLinkId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SecondaryMenuLinks/Edit').default,
                                        },
                                        {
                                            path: 'primary-menu-links',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/PrimaryMenuLinks').default,
                                        },
                                        {
                                            path: 'primary-menu-links/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/PrimaryMenuLinks/Create').default,
                                        },
                                        {
                                            path: 'primary-menu-links/:primaryMenuLinkId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/PrimaryMenuLinks/Edit').default,
                                        },
                                        {
                                            path: 'primary-menu-links/:primaryMenuLinkId/children/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/PrimaryMenuLinkChildren/Create').default,
                                        },
                                        {
                                            path: 'primary-menu-links/:primaryMenuLinkId/children/:primaryMenuLinkChildId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/PrimaryMenuLinkChildren/Edit').default,
                                        },
                                        {
                                            path: 'colors',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentColors').default,
                                        },
                                        {
                                            path: 'colors/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentColors/Create').default,
                                        },
                                        {
                                            path: 'colors/:contentColorId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentColors/Edit').default,
                                        },
                                        {
                                            path: 'job-regions',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobRegions').default,
                                        },
                                        {
                                            path: 'job-regions/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobRegions/Create').default,
                                        },
                                        {
                                            path: 'job-regions/:contentJobRegionId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobRegions/Edit').default,
                                        },
                                        {
                                            path: 'registration-categories',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrationCategories').default,
                                        },
                                        {
                                            path: 'registration-categories/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrationCategories/Create').default,
                                        },
                                        {
                                            path: 'registration-categories/:contentRegistrationCategoryId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrationCategories/Edit').default,
                                        },
                                        {
                                            path: 'registrations',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrations').default,
                                        },
                                        {
                                            path: 'registrations/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrations/Create/Company').default,
                                        },
                                        {
                                            path: 'registrations/create/:portalCompanyId',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrations/Create/Form').default,
                                            props: true
                                        },
                                        {
                                            path: 'registrations/:contentRegistrationId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentRegistrations/Edit').default,
                                        },
                                        {
                                            path: 'file-categories',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFileCategories').default,
                                        },
                                        {
                                            path: 'file-categories/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFileCategories/Create').default,
                                        },
                                        {
                                            path: 'file-categories/:contentFileCategoryId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFileCategories/Edit').default,
                                        },
                                        {
                                            path: 'files',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFiles').default,
                                        },
                                        {
                                            path: 'files/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFiles/Create/Company').default,
                                        },
                                        {
                                            path: 'files/create/:portalCompanyId',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFiles/Create/Form').default,
                                            props: true
                                        },
                                        {
                                            path: 'files/:contentFileId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentFiles/Edit').default,
                                        },
                                        {
                                            path: 'events',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEvents').default,
                                        },
                                        {
                                            path: 'events/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEvents/Create/Company').default,
                                        },
                                        {
                                            path: 'events/create/:portalCompanyId',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEvents/Create/Form').default,
                                            props: true
                                        },
                                        {
                                            path: 'events/:contentEventId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentEvents/Edit').default,
                                        },
                                        {
                                            path: 'jobs',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobs').default,
                                        },
                                        {
                                            path: 'jobs/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobs/Create/Company').default,
                                        },
                                        {
                                            path: 'jobs/create/:portalCompanyId',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobs/Create/Form').default,
                                            props: true
                                        },
                                        {
                                            path: 'jobs/:contentJobId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentJobs/Edit').default,
                                        },
                                        {
                                            path: 'articles',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticles').default,
                                        },
                                        {
                                            path: 'articles/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticles/Create/Company').default,
                                        },
                                        {
                                            path: 'articles/create/:portalCompanyId',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticles/Create/Form').default,
                                            props: true
                                        },
                                        {
                                            path: 'articles/:contentArticleId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticles/Edit').default,
                                        },
                                        {
                                            path: 'article-labels',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleLabels').default,
                                        },
                                        {
                                            path: 'article-labels/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleLabels/Create').default,
                                        },
                                        {
                                            path: 'article-labels/:contentArticleLabelId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/ContentArticleLabels/Edit').default,
                                        },
                                        {
                                            path: 'search-suggestions',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SearchSuggestions').default,
                                        },
                                        {
                                            path: 'search-suggestions/create',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SearchSuggestions/Create').default,
                                        },
                                        {
                                            path: 'search-suggestions/:searchSuggestionId/edit',
                                            component: require('./pages/Administration/Portals/Edit/Tabs/Content/SearchSuggestions/Edit').default,
                                        },
                                    ]
                                },
                                {
                                    path: 'magazine-recipients',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/MagazineRecipientList').default,
                                    meta: {subsection: 'magazine-recipients'}
                                },
                                {
                                    path: 'channels',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/ChannelList').default,
                                    meta: {subsection: 'channels'}
                                },
                                {
                                    path: 'channels/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreateChannel').default,
                                    meta: {subsection: 'channels'}
                                },
                                {
                                    path: 'time-channels/:timeChannelId',
                                    props: true,
                                    redirect: to => 'time-based-channels/' + to.params.timeChannelId
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditTimeBasedChannel').default,
                                    meta: {subsection: 'channels'},
                                    props: true,
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId/time-based-subchannels/:timeBasedSubchannelId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditTimeBasedSubchannel').default,
                                    meta: {subsection: 'channels'},
                                    props: true,
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId/time-based-subchannels/:timeBasedSubchannelId/ad-formats/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreateTimeAdFormat').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },
                                {
                                    path: 'time-based-channels/:timeBasedChannelId/time-based-subchannels/:timeBasedSubchannelId/ad-formats/:adFormatId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditTimeAdFormat').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },
                                {
                                    path: 'publication-channels/:publicationChannelId',
                                    props: true,
                                    redirect: to => 'publication-based-channels/' + to.params.publicationChannelId
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditPublicationBasedChannel').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId/publications/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreatePublication').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId/ad-formats/create',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/CreatePublicationBasedAdFormat').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },
                                {
                                    path: 'publication-based-channels/:publicationBasedChannelId/ad-formats/:adFormatId',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/EditPublicationBasedAdFormat').default,
                                    meta: {subsection: 'channels'},
                                    props: true
                                },


                                {
                                    path: 'budget',
                                    component: require('./pages/Administration/Portals/Edit/Tabs/Budget').default,
                                    meta: {subsection: 'budget'}
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'search',
                    component: require('./pages/Search/SearchResults/List').default,
                    meta: {
                        title: 'Search'
                    }
                },
                {
                    path: 'marketing-sites',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/MarketingSites/Portals/List').default,
                            meta: {
                                title: 'Marketing Sites'
                            }
                        },
                        {
                            path: ':portalId',
                            component: require('./pages/Administration/MarketingSites/Portals/Edit').default,
                            meta: {
                                title: 'Edit Marketing Site'
                            },
                            props: true
                        },
                        {
                            path: ':portalId/pages/:pageId',
                            component: require('./pages/Administration/MarketingSites/Pages/Edit').default,
                            meta: {
                                title: 'Edit Marketing Site'
                            },
                            props: true
                        },
                        {
                            path: ':portalId/pages/:pageId/blocks/create',
                            component: require('./pages/Administration/MarketingSites/Blocks/Create').default,
                            meta: {
                                title: 'Create Marketing Site Block'
                            },
                            props: true
                        },
                        {
                            path: ':portalId/pages/:pageId/blocks/:blockId',
                            component: require('./pages/Administration/MarketingSites/Blocks/Edit').default,
                            meta: {
                                title: 'Edit Marketing Site Block'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: 'gallery',
                    meta: {section: 'administration'},
                    component: require('./components/Blank').default,
                    children: [
                        {
                            path: '',
                            component: require('./pages/Administration/Images/List').default,
                            meta: {
                                title: 'Images'
                            }
                        }
                    ]
                }
            ]
        }
    ]
})
